//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SearchPro",
  layout: "public_new",
  data() {
    return {
      mapSearch: false,
      showButton: false
    }
  },
  head() {
    return {
      title: 'Расширенный поиск'
    }
  },
  mounted() {
    if (this.$route.query.search) {
      this.mapSearch = true
    }
  },
  methods: {
    toggleMapSearch() {
      this.mapSearch = !this.mapSearch
      // if (this.$route.query.search) {
      //   this.mapSearch = this.$router.push({ query: {} })
      // }
    },
    toggleMapView(value) {
      this.mapSearch = value
    },
    showToggleButton(value) {
      this.showButton = value
    }
  }
}
